import { render, staticRenderFns } from "./StatusRegisters.vue?vue&type=template&id=e9108db8&scoped=true&"
import script from "./StatusRegisters.vue?vue&type=script&lang=js&"
export * from "./StatusRegisters.vue?vue&type=script&lang=js&"
import style0 from "./StatusRegisters.vue?vue&type=style&index=0&id=e9108db8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9108db8",
  null
  
)

export default component.exports